import React from "react";
import { Table } from "reactstrap";
import { utils } from "../../../../utils/utils";

const QuoteRecapEquipmentRentalSection = ({ quoteItem }) => {
  const { quoteItemEquipmentRentals, margin } = quoteItem;

  const subtotal = quoteItemEquipmentRentals.reduce(
    (p, c) => p + parseFloat(c.cost),
    0
  );

  const totalSale = quoteItemEquipmentRentals.reduce((p, c) => {
    const itemMargin = c.percent || margin;
    return p + parseFloat(c.cost * (1 + itemMargin / 100));
  }, 0);

  return (
    <Table className="col-12 mt-4 px-0 border rounded mb-0">
      <tbody>
        {quoteItemEquipmentRentals
          .filter((rental) => rental.cost > 0)
          .sort(
            (x, y) =>
              x.equipmentRental?.code?.localeCompare(y.equipmentRental?.code) ||
              x.equipmentRental?.name?.localeCompare(y.equipmentRental?.name)
          )
          .map((rental) => {
            const { equipmentRental, cost, percent } = rental;
            const itemMargin = percent || margin;
            const sale = cost * (1 + itemMargin / 100);

            return (
              <tr key={rental.id}>
                <td className="py-0 text-truncate" width={"40%"}>
                  {equipmentRental.name}
                </td>
                <td className="py-0" width={"15%"} />
                <td className="py-0" width={"15%"}>
                  <div readOnly className="form-control border text-right m-1">
                    {utils.formatCurrency(cost)}
                  </div>
                </td>
                <td className="py-0" width={"15%"}>
                  <div readOnly className="form-control border text-right m-1">
                    {utils.formatPercent(itemMargin, 100)}
                  </div>
                </td>
                <td className="py-0" width={"15%"}>
                  <div readOnly className="form-control border text-right m-1">
                    {utils.formatCurrency(sale)}
                  </div>
                </td>
              </tr>
            );
          })}
        <tr>
          <td className="font-weight-bold py-0" width={"40%"}>
            Total Equipment Rentals
          </td>
          <td className="py-0" width={"15%"} />
          <td className="py-0" width={"15%"}>
            <div
              readOnly
              className="form-control border text-right m-1 font-weight-bold"
            >
              {utils.formatCurrency(subtotal)}
            </div>
          </td>
          <td className="py-0" width={"15%"} />
          <td className="py-0" width={"15%"}>
            <div
              readOnly
              className="form-control border text-right m-1 font-weight-bold"
            >
              {utils.formatCurrency(totalSale)}
            </div>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default QuoteRecapEquipmentRentalSection;
